export default {
  'inventory.create': 'Novo Inventário',
  'inventory.create.notifications.success.title': 'Sucesso',
  'inventory.create.notifications.success.description':
    'Inventário criado com Sucesso!',

  'inventory.report.notifications.success.title':
    'Relatório gerado com sucesso!',
  'inventory.report.notifications.success.description':
    'Relatório de serviço gerado com sucesso.',

  'inventory.notifications.remove.confirm.title':
    'Você deseja realmente excluir esse inventário?',
  'inventory.notifications.remove.confirm.content':
    'Ao remover o inventário, todas as informações serão perdidas permanentemente. Ainda sim deseja continuar?',
  'inventory.notifications.remove.confirm.okText': 'Remover inventário',
  'inventory.notifications.remove.confirm.cancelText': 'Cancelar',
  'inventory.notifications.remove.success.title':
    'Inventário removido com sucesso!',
  'inventory.notifications.remove.success.description':
    'O inventário foi removido com sucesso do sistema',

  'inventory.update.notification.success': 'Sucesso',
  'inventory.update.notification.successDescription': 'Inventário atualizado!',

  'inventory.columns.table.company': 'Empresa',
  'inventory.columns.table.date': 'Data',
  'inventory.columns.table.inventoryReason': 'Motivo Inventário',
  'inventory.columns.table.situation': 'Situação',
  'inventory.table.situation.inProgress': 'Em Progresso',
  'inventory.table.situation.processing': 'Finalizando Inventário',
  'inventory.table.situation.done': 'Finalizado',
  'inventory.table.situation.cancelled': 'Cancelado',
  'inventory.table.situation.importing': 'Importando',

  'inventory.form.modal.company': 'Empresa',
  'inventory.form.modal.inventoryReason': 'Motivo Inventário',
  'inventory.form.modal.inventoryReason.endOfPeriod': 'Final de Período',
  'inventory.form.modal.inventoryReason.changeFormGoods':
    'Mudança de forma de tributação de mercadoria',
  'inventory.form.modal.inventoryReason.registrationLowRequest':
    'Solicitação de baixa cadastral',
  'inventory.form.modal.inventoryReason.changeOfPaymentRegime':
    'Alteração de regime de pagamento',
  'inventory.form.modal.inventoryReason.taxDetermination':
    'Determinação do fisco',
  'inventory.form.modal.date': 'Data',
  'inventory.form.modal.inventoryOf': 'Vou fazer o inventário de:',
  'inventory.form.modal.radio.part': 'Peças',
  'inventory.form.modal.radio.consumables': 'Insumos',
  'inventory.form.modal.radio.all': 'Peças e Insumos',
  'inventory.form.modal.countFrom': 'Contagem a partir de:',

  'inventory.detailPage.form.button.launchItemCount':
    'Lançar contagem de itens',
  'inventory.detailPage.form.button.process': 'Processar',
  'inventory.detailPage.fetchItems.message.firstCount': 'º Contagem',
  'inventory.detailPage.form.company': 'Empresa',
  'inventory.detailPage.form.inventoryReason': 'Motivo Inventário',
  'inventory.detailPage.inventoryReason.endOfPeriod': 'Final de Período',
  'inventory.detailPage.inventoryReason.changeFormGoods':
    'Mudança de forma de tributação de mercadoria',
  'inventory.detailPage.inventoryReason.registrationLowRequest':
    'Solicitação de baixa cadastral',
  'inventory.detailPage.inventoryReason.changeOfPaymentRegime':
    'Alteração de regime de pagamento',
  'inventory.detailPage.inventoryReason.taxDetermination':
    'Determinação do fisco',
  'inventory.detailPage.form.date': 'Data',

  'inventory.page.form.modal.fetchItems.table.codeManufactures':
    'Cód. Fabricante',
  'inventory.page.form.modal.fetchItems.table.description': 'Descrição',
  'inventory.page.form.modal.fetchItems.table.manufacturingCode':
    'Código de Fabricação',
  'inventory.page.form.modal.fetchItems.table.barCode': 'Código de Barras',
  'inventory.page.form.modal.fetchItems.table.companyCode': 'Código da Empresa',
  'inventory.page.form.modal.fetchItems.table.sku': 'Código Interno',
  'inventory.page.form.modal.fetchItems.table.manufacturerCode':
    'Código de Fabricação',
  'inventory.page.form.modal.fetchItems.table.currentInventory':
    'Estoque atual',
  'inventory.page.form.modal.fetchItems.table.qtyCounted': 'Qtde contada',
  'inventory.page.form.modal.fetchItems.table.vlUnitary': 'Vl. unitário',
  'inventory.page.form.modal.fetchItems.table.vlAmount': 'Vl. Total',

  'inventory.page.form.modal.launchItemCount.title':
    'Lançamento dos itens de inventário',
  'inventory.page.form.modal.launchItems.subtitle':
    'Encontre uma Peça pelo código interno, de barras, do fabricante ou pela descrição:',
  'inventory.page.form.modal.launchItemCount.description': 'Descrição',
  'inventory.page.form.modal.launchItemCount.qtyCounted': 'Qtde contada',
  'inventory.page.form.modal.launchItemCount.currentInventory': 'Estoque atual',
  'inventory.page.form.modal.launchItemCount.codeManufacturers':
    'Código de Fabricação',
  'inventory.page.form.modal.launchItemCount.barCode': 'Cód. Barras',
  'inventory.page.form.modal.launchItemCount.internalCode': 'Cód. Interno',
  'inventory.page.form.modal.launchItemCount.code': 'Código',
  'inventory.page.form.modal.launchItemCount.unitaryValue': 'Valor Unitário',
  'inventory.page.form.modal.table.launchItemCount.score': 'Contagem',
  'inventory.page.form.modal.table.launchItemCount.qtyCounted': 'Qtde contada',

  'inventory.page.form.modal.processInventory.title':
    'Proximo passo do inventário:',
  'inventory.page.form.modal.processInventory.toNextCount':
    'Ir para a próxima contagem',
  'inventory.page.form.modal.processInventory.finalizeInventory':
    'Finalizar Inventário',

  'inventory.finalize.notification.success.title': 'Finalizando Inventário',
  'inventory.finalize.notification.success.description':
    'No momento em que seu inventário for finalizado o status mudará para "Finalizado"',
};
